import {Label} from '@primer/react'

import labelStyles from '../EntryStatusLabel.module.css'
import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function ClosedStatusLabel({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Closed) return null

  return (
    <Label variant="danger" className={labelStyles.solid}>
      Closed
    </Label>
  )
}
